// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"home-investors-module--wrapper--3DfuO","logos":"home-investors-module--logos--Ya46X"};